import React from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { Player } from 'video-react';
import 'video-react/dist/video-react.css';

import { connect } from './tableComponent';
import config from '../config';

class Component extends React.Component {
  render() {
    return (
      <div>
        <div class='row'>
          <div class='col-sm-12'>
            <div class='box mt-2 p-2'>
              <div class='tracker-description' style={{ fontSize: 14 }}>
                <div>
                  <h5 class='tracker-title text-center'>
                    Hello Best chatters, let's use this software to better manage all agents, <br />
                    and see their work live to make sure the dating sales are Valid!
                  </h5>
                </div>
                <div>
                  The software will track all chatted data and it will take print screens of the
                  agents screens every 5 minutes and publish on a discord channel that you choose!
                  So you will be able to verify in discord all the print screens of the monitors of
                  all agents. You will create a chat room called Bestchatters, and for each agent
                  you will create a subroom example agent1, agent2, etc. The Chat room manager will
                  be able to login in all agent subrooms to check keylogs and print screens of their
                  monitors. Each agent must install the zip above on their computer, and add the
                  discord subroom as parameter as shown in this video below :
                </div>
              </div>
              <div class='text-center p-2'>
                <a class='btn warning tracker-btn' href='/app/assets/tracker/BestChatters.zip'>
                  Download app
                </a>
              </div>
              <div class='cp-player'>
                <div>Scroll down for the video</div>
                <Player poster='/app/assets/tracker/thumbnail.png'>
                  <source src='/app/assets/tracker/bestchatters.mp4' />
                </Player>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(Component, 'tracker');
